(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/init.js');
"use strict";



(function (svs, ReactDOM) {
  'use strict';

  svs.grassroots_partner.createStore();
  const router = svs.utils.reactHelpUtils.createRouter({
    startPage: () => React.createElement(svs.grassroots_partner.StartPage, null),
    foreningAnsluten: () => React.createElement(svs.grassroots_partner.ClubAdded, null),
    inloggning: () => React.createElement(svs.grassroots_partner.Login, null),
    oversikt: () => React.createElement(svs.grassroots_partner.Overview, null),
    inloggningStangd: () => React.createElement(svs.grassroots_partner.LoginClosed, null)
  });
  const _ReactRedux = ReactRedux,
    Provider = _ReactRedux.Provider;
  ReactDOM.render(React.createElement(Provider, {
    store: svs.grassroots_partner.store
  }, router), document.getElementById('grassroots-partner-container'));
})(svs, ReactDOM);

 })(window);